export const LOCALES = ["ru", "en", "hi", "tr", "de", "fr", "es", "sr"] as const;
export type Locale = (typeof LOCALES)[number];

/** English and Russian are mandatory; other languages fall back to English. */
export type LocalizedText = { en: string; ru: string } & Partial<Record<Locale, string>>;

export function pickText(text: LocalizedText, locale: Locale): string {
  return text[locale] || text.en;
}

/** Native names for the language picker. */
export const LOCALE_NAMES: Record<Locale, string> = {
  ru: "Русский", en: "English", hi: "हिन्दी", tr: "Türkçe", de: "Deutsch", fr: "Français", es: "Español", sr: "Српски",
};
